module.exports = __webpack_public_path__ + "img/eye.2c5e4246.svg";